export default __webpack_public_path__ + "static/media/Avenir-Roman.4feb8919.woff2";